export default __webpack_public_path__ + "static/media/Achievments2.3840111f.png";